module.exports = __webpack_public_path__ + "img/img-meal-plan-empty.6ee6e06c.svg";